<template>
  <div class="container">
    <AppNavbar
      :placeholder="true"
      :options="options"
      :zIndex="20"
      title="签到奖品列表"
    ></AppNavbar>
    <div class="scroll">
      <div class="prize-container" v-if="prizeList.length">
        <div class="prize-list">
          <div
            class="prize-item"
            v-for="(item, index) in prizeList"
            :key="index"
          >
            <img class="item-icon" :src="item.win_icon" alt="" />
            <div class="item-center">
              <div
                ><span class="item-title">{{ item.win_goods_name }}</span
                ><span class="item-num">x{{ item.reward_num }}</span>
              </div>
              <div class="item-time">{{ item.created_at }}</div>
            </div>
            <div
              class="item-btn"
              @click="bindClick(item)"
              :class="{ 'item-btn-confirm': item.tab_txt == '已到账' }"
              >{{ item.tab_txt
              }}<span
                class="iconfont icon-you"
                v-if="item.tab_txt != '已到账'"
              ></span
            ></div>
          </div>
        </div>
        <div class="all">
          <div class="text">已展示全部</div>
        </div>
      </div>
      <div class="not-data" v-if="loaded && !prizeList.length">
        <div>
          <img
            class="not-data-image"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/eedeb209b75749ab169fb16d10bc6e77.webp"
            alt=""
          />
          <div class="not-data-text"
            >这里还空空如也<br />
            赶快去签到获取超值好礼吧！</div
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  data() {
    return {
      options: {
        textAlign: 'left'
      },
      loaded: false,
      prizeList: []
    }
  },
  created() {
    this.getPrizeList()
  },
  methods: {
    bindClick(item) {
      if (item.coil_url) {
        this.$betterwe.jumpRoute(item.coil_url)
      }
    },
    async getPrizeList() {
      let res = await this.$http
        .getAppWithAppInfo('api/v1/SignActivity/getSignGoods', {
          activity_id: 1
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.prizeList = res.data || []
        } else {
          this.$toast(res.msg)
        }
      }
      this.loaded = true
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background: #f9f9f9;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.scroll {
  flex: 1;
  flex-shrink: 0;
  overflow: scroll;
}
.prize-container {
  padding: 0px 16px;
  margin-top: 16px;

  .prize-list {
    margin-bottom: 16px;

    .prize-item {
      padding: 13px 15px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 8px;

      .item-icon {
        width: 40px;
        height: 40px;
        object-fit: contain;
        margin-right: 10px;
      }

      .item-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 10px;

        .item-title {
          font-size: 15px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 24px;
          margin-right: 6px;
        }

        .item-num {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ff6464;
          line-height: 22px;
        }

        .item-time {
          margin-top: 5px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 18px;
        }
      }

      .item-btn {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 12px;

        .iconfont {
          margin-left: 2px;
          color: rgba(0, 0, 0, 0.5);
        }
      }

      .item-btn-confirm {
        color: rgba(0, 0, 0, 0.3);
      }
    }

    .prize-item:last-child {
      margin-bottom: 0;
    }
  }

  .all {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(0, 0, 0, 0.3);
    line-height: 18px;
    margin-bottom: 42px;

    .text {
      position: relative;
    }

    .text::before {
      content: '';
      position: absolute;
      right: calc(100% + 10px);
      top: 50%;
      width: 30px;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.1);
    }

    .text::after {
      content: '';
      position: absolute;
      left: calc(100% + 10px);
      top: 50%;
      width: 30px;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}

.not-data {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .not-data-image {
    width: 214px;
    height: 112px;
    object-fit: contain;
    margin-bottom: 16px;
  }

  .not-data-text {
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    color: rgba(51, 51, 51, 0.5);
    line-height: 20px;
  }
}
</style>
